import React from "react";

export default function ActivityChart({ events, months, onMonthsChange }) {
  const today = new Date();
  const buckets = Array.from({ length: months }, (_, index) => {
    const start = new Date(
      today.getFullYear(),
      today.getMonth() - months + index + 1,
      1,
    );
    const end = new Date(start.getFullYear(), start.getMonth() + 1, 1);
    return {
      label: start.toLocaleDateString("en", { month: "short" }),
      date: start.toLocaleDateString("en", { month: "short", year: "numeric" }),
      count: events.filter(({ event_date_start }) => {
        const date = new Date(event_date_start);
        return event_date_start && date >= start && date < end;
      }).length,
    };
  });
  const peak = Math.max(0, ...buckets.map(({ count }) => count));
  const step = Math.max(1, Math.ceil(peak / 3 / 5) * 5);
  const maximum = step * 3;
  const total = buckets.reduce((sum, bucket) => sum + bucket.count, 0);

  return (
    <section
      className="dashboard-panel activity-panel"
      aria-labelledby="activity-title"
    >
      <div className="panel-heading">
        <div>
          <h2 id="activity-title">Event activity</h2>
          <p>
            {buckets[0].date} — {buckets[months - 1].date}
          </p>
        </div>
        <div
          className="period-toggle"
          role="group"
          aria-label="Chart time period"
        >
          {[6, 12].map((value) => (
            <button
              key={value}
              aria-pressed={months === value}
              onClick={() => onMonthsChange(value)}
            >
              {value} months
            </button>
          ))}
        </div>
      </div>
      <div className="activity-summary">
        <strong>{total.toLocaleString()}</strong>
        <span>events in this period</span>
      </div>
      <div
        className={`activity-chart months-${months}`}
        role="img"
        aria-label={`Monthly event counts. ${buckets.map(({ date, count }) => `${date}: ${count}`).join("; ")}`}
      >
        <div className="chart-y-axis" aria-hidden="true">
          {[3, 2, 1, 0].map((tick) => (
            <span key={tick}>{tick * step}</span>
          ))}
        </div>
        <div className="chart-plot">
          <div className="chart-grid" aria-hidden="true">
            <i />
            <i />
            <i />
            <i />
          </div>
          <div className="chart-bars" aria-hidden="true">
            {buckets.map(({ label, date, count }, index) => (
              <div className="chart-column" key={date}>
                <div className="bar-track">
                  {count > 0 ? (
                    <div
                      title={`${date}: ${count} events`}
                      className={`chart-bar ${count === peak ? "peak" : ""}`}
                      style={{ height: `${(count / maximum) * 100}%` }}
                    >
                      <span>{count}</span>
                    </div>
                  ) : (
                    <span className="zero-value">0</span>
                  )}
                </div>
                <span className={index % 2 === 1 ? "alternate-month" : ""}>
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="chart-caption">
        <span>
          <i />
          Events by scheduled date
        </span>
        <span>Includes the current month</span>
      </div>
      {total === 0 && (
        <p className="chart-empty-note">
          No events in this period. Try a wider date range.
        </p>
      )}
    </section>
  );
}
